import styled from 'styled-components'

export const TaskTextarea = styled.textarea`
    outline: none;
    border: none;
    border-bottom: 1px solid #000;
    margin-top: 10px;
` 